
import React from 'react';
import PropTypes from 'prop-types';

const CASummaryLocationInfo = props => {

  return (
    <div className="summary-info">
      {props.selectedLocation &&
      <div>
        <div className="contract-info-row">
          <div>
            <span className="contract-info-heading">Location City&nbsp;</span>
            <span>{props.selectedLocation.city}</span>
          </div>
        </div>
        <div className="loc-info-row">
          <div>
            <span className="contract-info-heading">Location State&nbsp;</span>
            <span>{props.selectedLocation.state}</span>
          </div>
        </div>
        <div className="loc-info-row">
          <div>
            <span className="contract-info-heading">Location Contact&nbsp;</span>
            <span>{props.selectedLocation.contactName}</span>
          </div>
        </div>
      </div>
      } 
    </div>
  );
};
CASummaryLocationInfo.propTypes = {
  selectedLocation: PropTypes.arrayOf(PropTypes.object),
};

export default CASummaryLocationInfo;